import React, { memo, useMemo } from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { Accordian, AccordianMapping } from '@modules/common/Accordian';
import { Button } from 'reactstrap';
import { FormSelectItem } from '@core/components/form';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { ProjectListCategoryForm } from '../ProjectListBlock';
import { ProjectListCategoryContent } from './ProjectListCategoryContent';

const DragHandle = SortableHandle(() => <i className="fas fa-grip-vertical mr-2" style={{ cursor: 'move', color: '#6c757d' }} />);

interface ProjectListCategoryItemProps {
  categoryCtrl: ProjectListCategoryForm;
  categoryIndex: number;
  categoryItems: FormSelectItem<any, any>[];
  onDelete: () => void;
}

export const ProjectListCategoryItem = SortableElement(
  memo((props: ProjectListCategoryItemProps) => {
    const { categoryCtrl, categoryIndex, categoryItems, onDelete } = props;
    const categoryValue = useNonNilObservable(categoryCtrl.value$);

    const categoryName = useMemo(() => {
      const selected = categoryItems.find(item => item.value === categoryValue.categoryId);
      return selected ? selected.label : `Category ${categoryIndex + 1}`;
    }, [categoryItems, categoryValue.categoryId, categoryIndex]);

    const tabs: AccordianMapping[] = useMemo(
      () => [
        {
          title: (
            <div className="d-flex justify-content-between align-items-center w-100">
              <span className="d-flex align-items-center">
                <DragHandle />
                {categoryName}
              </span>
              <Button
                color="danger"
                size="sm"
                outline
                onClick={e => {
                  e.stopPropagation();
                  onDelete();
                }}
              >
                <i className="fas fa-trash"></i>
              </Button>
            </div>
          ),
          component: ProjectListCategoryContent,
          props: { categoryCtrl, categoryIndex, categoryItems },
        },
      ],
      [categoryName, categoryCtrl, categoryIndex, categoryItems, onDelete],
    );

    return (
      <div className="mb-2">
        <Accordian tabs={tabs} initialIndex={-1} />
      </div>
    );
  }),
);
